// extracted by mini-css-extract-plugin
export default {"input":"TheInput_input_TTboL","disabled":"TheInput_disabled_kOxyu"};